import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// ---------- Public site reads ----------
export const submitContact = (payload) => apiClient.post("/contact", payload).then((r) => r.data);
export const getSiteSettings = () => apiClient.get("/site/settings").then((r) => r.data);
export const getSiteHero = () => apiClient.get("/site/hero").then((r) => r.data);
export const getSiteAbout = () => apiClient.get("/site/about").then((r) => r.data);
export const getSiteServices = () => apiClient.get("/site/services").then((r) => r.data);
export const getSiteGallery = () => apiClient.get("/site/gallery").then((r) => r.data);
export const getSiteNav = () => apiClient.get("/site/nav").then((r) => r.data);

// ---------- Auth ----------
export const login = (email, password) =>
  apiClient.post("/auth/login", { email, password }).then((r) => r.data);
export const logout = () => apiClient.post("/auth/logout").then((r) => r.data);
export const me = () => apiClient.get("/auth/me").then((r) => r.data);

// ---------- Admin ----------
export const adminGet = (path) => apiClient.get(`/admin${path}`).then((r) => r.data);
export const adminPut = (path, body) => apiClient.put(`/admin${path}`, body).then((r) => r.data);
export const adminPost = (path, body) => apiClient.post(`/admin${path}`, body).then((r) => r.data);
export const adminDelete = (path) => apiClient.delete(`/admin${path}`).then((r) => r.data);

export const adminUploadMedia = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const r = await axios.post(`${API}/admin/media/upload`, form, {
    withCredentials: true,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
};

// Format API error details (handles FastAPI's array of {msg} validation errors)
export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// Resolve relative media URLs (e.g. /api/files/xxx) against backend URL
export const resolveAssetUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
